"use client"
import { useEffect } from 'react'
import { useThemeToggle } from '@/hooks/theme/useThemeToggle'

/**
 * Composant client pour gérer dynamiquement les meta tags theme-color et color-scheme
 * Ce composant doit être utilisé dans le layout pour synchroniser
 * les meta tags avec le thème actuel
 */
export default function ThemeColorMeta() {
  const { getEffectiveTheme } = useThemeToggle()

  useEffect(() => {
    const updateThemeMeta = () => {
      const effectiveTheme = getEffectiveTheme()
      const themeColor = effectiveTheme === 'light' ? '#ffffff' : '#000000'
      
      // Mettre à jour ou créer la meta tag theme-color
      const metaThemeColor = document.querySelector('meta[name="theme-color"]')
      if (metaThemeColor) {
        if (metaThemeColor.getAttribute('content') !== themeColor) {
          metaThemeColor.setAttribute('content', themeColor)
        }
      } else {
        // Créer la meta tag si elle n'existe pas
        const newMetaThemeColor = document.createElement('meta')
        newMetaThemeColor.name = 'theme-color'
        newMetaThemeColor.content = themeColor
        document.head.appendChild(newMetaThemeColor)
      }

      // Mettre à jour ou créer la meta tag color-scheme
      const metaColorScheme = document.querySelector('meta[name="color-scheme"]')
      if (metaColorScheme) {
        if (metaColorScheme.getAttribute('content') !== effectiveTheme) {
          metaColorScheme.setAttribute('content', effectiveTheme)
        }
      } else {
        // Créer la meta tag si elle n'existe pas
        const newMetaColorScheme = document.createElement('meta')
        newMetaColorScheme.name = 'color-scheme'
        newMetaColorScheme.content = effectiveTheme
        document.head.appendChild(newMetaColorScheme)
      }
    }

    // Mettre à jour au montage du composant
    updateThemeMeta()

    // Écouter les changements de thème système
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = () => updateThemeMeta()
    
    mediaQuery.addEventListener('change', handleChange)
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [getEffectiveTheme])

  // Ce composant ne rend rien visuellement
  return null
}
